import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const hasModuleAsignacionEmailReglas = store.getters['auth/hasModuleAsignacionEmailReglas']
  const menu = [
    {
      icon: 'config',
      name: i18n.t('app.rules'),
      path: 'configurations/rules',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'configurations/rules/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.groups_link'),
          path: 'configurations/rules/groups',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
      ]
    }
  ]
  const submenuHistorical = {
    name: i18n.t('app.historical'),
    path: 'configurations/rules/historical',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const submenuEmails = {
    name: i18n.t('app.emails_link'),
    path: 'configurations/rules/emails',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const submenuMetadata = {
    name: i18n.t('app.metadata'),
    path: 'configurations/rules/metadata',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }

  if (hasModuleAsignacionEmailReglas) {
    menu[0].sc.push(submenuEmails)
  }
  menu[0].sc.push(submenuMetadata)
  menu[0].sc.push(submenuHistorical)
  
  return menu
}
